import React, { Component } from 'react';
import { Alert } from 'react-bootstrap';
import '../../content/css/ContractReviewer.css';

export default class AlertDismissable extends Component {
    constructor(props, context) {
        super(props, context);

        this.handleDismiss = this.handleDismiss.bind(this);
        this.handleShow = this.handleShow.bind(this);

        this.state = {
            show: true
        };
    }

    handleDismiss() {
        this.setState({ show: false });
    }

    handleShow() {
        this.setState({ show: true });
    }

    render() {
        return (
            <React.Fragment>
                {this.state.show && (
                    <Alert bsStyle="danger" onDismiss={this.handleDismiss}>
                        <h4>Beware!</h4>
                        <p>
                            Do not upload documents classified as <strong>STRICTLY CONFIDENTIAL</strong> to this service!
                    </p>
                    </Alert>)
                }
            </React.Fragment>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Upload/AlertDismissable.js